/* 
 * This file is part of Tibia Wheel.
 * Copyright (c) 2022 Maciej Sopyło
 * 
 * Tibia Wheel is free software: you can redistribute it and/or modify  
 * it under the terms of the GNU Lesser General Public License as published by  
 * the Free Software Foundation, version 3.
 *
 * Tibia Wheel is distributed in the hope that it will be useful, but 
 * WITHOUT ANY WARRANTY; without even the implied warranty of 
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU 
 * General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License 
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

.icon {
  --size: 16px;
  display: inline-block;
  width: var(--size);
  height: var(--size);
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: calc(var(--icon) * var(--size) * -1);

  &.dedication {
    background-image: url(../../assets/skillwheel/icons-skillwheel-smallperks.png?as=webp);
  }
  &.conviction {
    background-image: url(../../assets/skillwheel/icons-skillwheel-mediumperks.png?as=webp);
  }
  &.revelation {
    background-image: url(../../assets/skillwheel/icons-skillwheel-largeperks.png?as=webp);
  }
}
